// extracted by mini-css-extract-plugin
export default {"disputes-wrapper":"disputes_disputes-wrapper__UtYn7","disputes-wrapper__need-help-text":"disputes_disputes-wrapper__need-help-text__qLlnK"};